import { graphql } from '../../gql';

export const GET_USER_REPORTS = graphql(`
  query GetUserReports($ids: [String!]!) {
    users(ids: $ids) {
      reports {
        uuid
        job_id
        job_name
        name
        client
        status
        report {
          reportType
          mainEntities {
            type
            values
          }
          comparisonEntities {
            type
            values
          }
          filters {
            type
            id
            values
          }
        }
        created_at
        updated_at
      }
    }
  }
`);
